import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from "primereact/inputnumber";
import { Select, Textfield } from "../../../../components/core";
function filterUniqueValues(arr) {
	const valueCount = {};

	arr.forEach((item) => {
		if (valueCount[item.value]) {
			valueCount[item.value]++;
		} else {
			valueCount[item.value] = 1;
		}
	});

	const filteredArray = arr.filter((item) => valueCount[item.value] === 1);

	return filteredArray;
}
export default function CellEditingTable({
	data = [
		{
			partnerCodPaymentFeeId: 1,
			paymentModeId: 1,
			partnerId: 1,
			codRate: 1,
		},
		{
			partnerCodPaymentFeeId: 2,
			paymentModeId: 2,
			partnerId: 2,
			codRate: 2,
		},
	],
	editedData,
	headers = [
		{
			field: "paymentModeId",
			header: "Payment Mode",
			type: "select",
			items: [],
		},
		{ field: "codRate", header: "Rate", type: "numberfield" },
	],
	handleOnCellEditComplete,
	loading,
	primaryKey,
	paymentModeList,
	currentPaymentMode,
}) {
	const [localData, setLocalData] = React.useState([]);
	console.log({ data, editedData });
	React.useEffect(() => {
		setLocalData([]);
		setLocalData(JSON.parse(JSON.stringify(data)));
	}, [data]);
	const onCellEditComplete = (e) => {
		// get the event object
		let { rowData, newValue, field } = e;
		// Localy assigned the table
		rowData[field] = newValue;
		// Edit the list of user types
		handleOnCellEditComplete(
			data.findIndex((x) => x[primaryKey] === rowData[primaryKey]),
			newValue,
			field
		);
		console.log("Cell Editing Done" + newValue);
	};

	const cellEditor = (options, type) => {
		switch (type) {
			case "select":
				return selectEditor(options);
			case "numberfield":
				return percentageEditor(options);
			default:
				return textEditor(options);
		}
	};

	const textEditor = (options) => {
		return (
			<Textfield
				value={options.value}
				onChange={(e) => options.editorCallback(e.target.value)}
			/>
		);
	};
	const selectEditor = (options) => {
		let tempCurrentPaymentMode = [...currentPaymentMode];
		tempCurrentPaymentMode.push(
			paymentModeList.find((x) => x.value === options.value)
		);
		return (
			<Select
				disable={data.length < 3 ? false : true}
				items={tempCurrentPaymentMode}
				value={options.value}
				onChange={(e) => options.editorCallback(e.target.value)}
			/>
		);
	};
	const customBodyForSelect = (rowValue) => {
		return (
			<p>
				{paymentModeList.find((x) => x.value === rowValue.paymentModeId) &&
					paymentModeList.find((x) => x.value === rowValue.paymentModeId).name}
			</p>
		);
	};
	const customBodyForPercentage = (rowValue) => {
		return <p>{rowValue.codRate}%</p>;
	};
	const percentageEditor = (options) => {
		return (
			<Textfield
				maxFractionDigits={2}
				value={options.value}
				onChange={(e) => {
					var numberPattern = /^\d+(\.\d{0,2})?$/;
					if (numberPattern.test(e.target.value) || e.target.value === "") {
						if (parseFloat(e.target.value) <= 99.0 || e.target.value === "")
							options.editorCallback(e.target.value);
					}
				}}
			/>
		);
	};

	return (
		<div className="card p-fluid">
			<DataTable
				paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
				currentPageReportTemplate="Rows per page"
				paginator
				rowsPerPageOptions={[10, 20, 50]}
				rows={10}
				showGridlines={true}
				stripedRows
				sortMode="multiple"
				removableSort
				cellSelection
				selectionMode="single"
				value={localData}
				tableStyle={{
					minWidth: "50rem",
					//   wordWrap: "break-word",
					//   tableLayout: "fixed",
				}}
			>
				{headers.map(({ field, header, type }) => {
					if (type === "numberfield") {
						return (
							<Column
								key={field}
								field={field}
								header={header}
								style={{ width: "25%" }}
								headerStyle={{
									backgroundColor: "#FECD08",
									color: "black",
								}}
								sortable
								body={customBodyForPercentage}
								editor={(options) => cellEditor(options, type)}
								onCellEditComplete={onCellEditComplete}
							/>
						);
					}
					return (
						<Column
							key={field}
							field={field}
							header={header}
							style={{ width: "50%" }}
							sortable
							headerStyle={{
								backgroundColor: "#FECD08",
								color: "black",
							}}
							body={customBodyForSelect}
							editor={(options) => cellEditor(options, type)}
							onCellEditComplete={onCellEditComplete}
						/>
					);
				})}
			</DataTable>
		</div>
	);
}
